// Historical Candles client.

import { fetchJson, URLS } from "./client";
import type { CandleDto, CandleInterval, MarketType } from "./types";

export function fetchLatestCandles(
  coin: string,
  interval: CandleInterval,
  marketType: MarketType,
  count = 500,
  signal?: AbortSignal,
): Promise<CandleDto[]> {
  const url = `${URLS.historicalCandles}/Candles/latest`
    + `?coin=${encodeURIComponent(coin)}`
    + `&interval=${encodeURIComponent(interval)}`
    + `&marketType=${encodeURIComponent(marketType)}`
    + `&count=${count}`;
  return fetchJson<CandleDto[]>(url, { signal });
}
